export const STATSIG_EVENTS = {
  memoryModuleClick: 'memory_module_click',
  quickActionMemoryClick: 'quick_action_memory_click',
  quickActionReportGroupsClick: 'quick_action_report_groups_click',
  quickActionSyncWebsiteClick: 'quick_action_sync_website_click',
  quickActionChatSpaceMemoryClick: 'quick_action_chat_space_memory_click',
  memoryTabClick: 'memory_tab_click',
  gettingStartedPrimaryCtaClick: 'getting_started_primary_cta_click',
  gettingStartedChecklistItemClick: 'getting_started_checklist_item_click',
  gettingStartedDocsClick: 'getting_started_docs_click',
  gettingStartedSupportClick: 'getting_started_support_click',
  activationWorkspaceViewed: 'activation_workspace_viewed',
  activationCardViewed: 'activation_card_viewed',
  activationCardCtaClick: 'activation_card_cta_click',
  activationSuggestionCopied: 'activation_suggestion_copied',
  activationRecommendationAccepted: 'activation_recommendation_accepted',
} as const;

export type StatsigEvent = (typeof STATSIG_EVENTS)[keyof typeof STATSIG_EVENTS];
